export const DOC_CONFIGS = {
  invoices: {
    endpoint: "invoices", title: "Invoice", refKey: "invoice_no", refLabel: "Invoice No",
    dateKey: "invoice_date", dateLabel: "Invoice Date", pdfType: "invoice", showPaid: true, salesCharges: true, shareWhatsapp: true,
    manualRef: true, prefixKey: "invoice_prefix", docExpenses: true,
    module: "sales", gst: true, defaultGst: 18,
    lineGrade: true, lineGst: true,
    statuses: ["Unpaid", "Partial", "Paid", "Cancelled"],
    party: { endpoint: "customers", label: "Customer", idKey: "customer_id", nameKey: "customer_name", labelKey: "company_name", valueKey: "id", activeOnly: true, copyBilling: true },
    extraHeader: [{ name: "due_date", label: "Due Date", type: "date" }, { name: "payment_terms", label: "Payment Terms" }],
    extraFooter: [{ name: "billing_address", label: "Billing Address (Bill To)" }, { name: "shipping_name", label: "Shipping Name (optional)" }, { name: "shipping_address", label: "Shipping Address (Ship To)" }, { name: "notes", label: "Notes" }],
  },
  quotations: {
    endpoint: "quotations", title: "Quotation", refKey: "quotation_no", refLabel: "Quotation No",
    dateKey: "quotation_date", dateLabel: "Quotation Date", pdfType: "quotation",
    manualRef: true, prefixKey: "quotation_prefix", convertible: true,
    module: "quotations", gst: true, defaultGst: 18,
    lineGrade: true,
    statuses: ["Draft", "Sent", "Accepted", "Rejected", "Expired", "Cancelled"],
    party: { endpoint: "customers", label: "Customer", idKey: "customer_id", nameKey: "customer_name", labelKey: "company_name", valueKey: "id", activeOnly: true, copyBilling: true },
    extraHeader: [{ name: "valid_until", label: "Valid Until", type: "date" }],
    extraFooter: [{ name: "billing_address", label: "Billing Address (Bill To)" }, { name: "shipping_name", label: "Shipping Name (optional)" }, { name: "shipping_address", label: "Shipping Address (Ship To)" }, { name: "notes", label: "Notes" }],
  },
  "proforma-invoices": {
    endpoint: "proforma-invoices", title: "Proforma Invoice", refKey: "proforma_no", refLabel: "PI No",
    dateKey: "proforma_date", dateLabel: "PI Date", pdfType: "proforma",
    manualRef: true, autoNextNo: true, convertible: true, convertEndpoint: "proforma-invoices",
    duplicable: true, printable: true, lockWhenConverted: true,
    extraColumns: [{ key: "proforma_date", label: "PI Date", format: "date" }, { key: "valid_until", label: "Valid Until", format: "date" }],
    module: "quotations", gst: true, defaultGst: 18,
    lineGrade: true, lineGst: true, piCharges: true,
    statuses: ["Draft", "Sent", "Accepted", "Rejected", "Expired", "Converted to Sales Invoice"],
    party: { endpoint: "customers", label: "Customer", idKey: "customer_id", nameKey: "customer_name", labelKey: "company_name", valueKey: "id", activeOnly: true, copyBilling: true },
    extraHeader: [{ name: "valid_until", label: "Valid Until", type: "date" }, { name: "payment_terms", label: "Payment Terms" }],
    extraFooter: [{ name: "billing_address", label: "Billing Address (Bill To)" }, { name: "shipping_name", label: "Shipping Name (optional)" }, { name: "shipping_address", label: "Shipping Address (Ship To)" }, { name: "notes", label: "Notes" }],
  },
  "purchase-orders": {
    endpoint: "purchase-orders", title: "Purchase Order", refKey: "po_no", refLabel: "PO No",
    dateKey: "po_date", dateLabel: "PO Date", pdfType: "purchase_order", documentsType: "purchase_order",
    manualRef: true, prefixKey: "po_prefix",
    module: "purchase", gst: true, defaultGst: 5,
    lineGrade: true,
    statuses: ["Pending", "Confirmed", "Received", "Cancelled"],
    party: { endpoint: "suppliers", label: "Supplier", idKey: "supplier_id", nameKey: "supplier_name", labelKey: "supplier_name", valueKey: "id" },
    extraHeader: [{ name: "expected_date", label: "Expected Delivery Date", type: "date" }, { name: "warehouse", label: "Warehouse" }],
    extraFooter: [{ name: "notes", label: "Notes" }],
  },
  "purchase-bills": {
    endpoint: "purchase-bills", title: "Purchase Bill", refKey: "bill_no", refLabel: "Bill No",
    dateKey: "bill_date", dateLabel: "Bill Date", pdfType: "purchase_bill", showPaid: true, documentsType: "purchase_bill",
    manualRef: true, docExpenses: true,
    module: "purchase_bills", gst: true, defaultGst: 5,
    lineGrade: true, lineBatch: true, lineGst: true, additionalExpenses: true, attachments: true, attachmentModule: "purchase",
    landedExpenses: true,
    statuses: ["Unpaid", "Partial", "Paid", "Cancelled"],
    party: { endpoint: "suppliers", label: "Supplier", idKey: "supplier_id", nameKey: "supplier_name", labelKey: "supplier_name", valueKey: "id" },
    extraHeader: [{ name: "po_no", label: "Purchase Order No" }, { name: "due_date", label: "Due Date", type: "date" }, { name: "warehouse", label: "Warehouse" }],
    extraFooter: [{ name: "notes", label: "Notes" }],
  },
  "sales-returns": {
    endpoint: "sales-returns", title: "Sales Return", refKey: "return_no", refLabel: "Return / Credit Note No",
    dateKey: "return_date", dateLabel: "Return Date", pdfType: "sales_return",
    module: "sales", gst: true, defaultGst: 18,
    lineGrade: true,
    statuses: ["Recorded", "Cancelled"],
    party: { endpoint: "invoices", label: "Original Invoice", idKey: "invoice_id", nameKey: "invoice_no", labelKey: "invoice_no", valueKey: "id" },
    extraHeader: [{ name: "reason", label: "Reason for Return" }],
    extraFooter: [{ name: "notes", label: "Notes" }],
  },
};
